/**
 * Map Anmälningar API error codes to i18n keys; fall back to server message.
 * @param {import('i18next').TFunction} t
 * @param {unknown} err
 * @param {string} fallbackKey
 */
export function resolveAnmalningApiError(t, err, fallbackKey) {
  const code = err?.response?.data?.code;
  const serverMsg = err?.response?.data?.error;
  if (code) {
    const key = `anmalningar_error_${code}`;
    const translated = t(key);
    if (translated !== key) return translated;
  }
  if (serverMsg && typeof serverMsg === "string") return serverMsg;
  return t(fallbackKey);
}
